import { ShopCode } from '@/utils/shop'
import { ABTestInputCondition, abTestGlobalKey } from '../abtestV2'

export const PDP_LEVERSPHERE_LOOP_EXPERIMENT_CAMPAIGN: ABTestInputCondition = {
  code: 'pdp_leversphere_loop_campaign',
  exprId: 'pdp_leversphere_loop',
  exprName: 'PDP Combo Pack For Ornament Product UI Experiment',

  startDate: '2026-08-28T00:00:00Z',
  stopDate: '2026-11-28T23:59:59Z',
  endDate: '2026-11-28T23:59:59Z',

  endIfPurchased: false,

  trafficRate: 1,
  variants: [
    { code: abTestGlobalKey.groupControl, rate: 0.5 },
    { code: abTestGlobalKey.groupTreatment, rate: 0.5 },
  ],

  allowedDevices: [],
  allowedCountries: [],
  allowedStores: [ShopCode.SUN],
  allowedUrls: [
    'always-by-my-side-personalized-dog-plush-keychain-10308040426scl1cle1tu08nh02my04plk1_ipatudog00848',
    'mini-me-personalized-kid-plush-keychain-10325220426scl1cle1tr04cu03my04plk1_ipatukid00641',
    'love-cruising-personalized-cruising-magnet-10825040626scl1cle1ph08ph01du10mag1_ipatucrs00009',
    'the-funny-mystery-dumpling-for-kid-personalized-kid-keychain-10145270726scl1cle1tr04cu03li09kch1_ipatukid00904',
    'im-always-with-you-personalized-memorial-plush-ornament-10449180826scl1cle1tu08cu03my04plo1_ipatudth00422',
    'fly-attendant-custom-luggage-tag-personalized-fly-attendant-luggage-tag-10831140526scl1cle1tu08ph01li09slt1_ipatufad00002',
    'always-with-you-personalized-memorial-plush-keychain-10281030426scl1cle1tu08ha09my04plk1_ipatudth00288',
    'cruise-memory-personalized-cruising-magnet-10662260526scl1cle1ph08ph01tr18mag1_ipatucrs00007',
  ],
}
